import { Radio } from '@gcommon/gcommon-ui'
import { defineComponent, reactive } from '@vue/composition-api'
import { number } from 'echarts'
import './index.scss'
const BarScore = defineComponent({
  props: {
    minScoreDesc: {
      type: String,
      default: '很不满意'
    },
    maxScoreDesc: {
      type: String,
      default: '很满意'
    },
    maxScore: {
      type: Number,
      default: 10
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Number, String],
      default: ''
    },
    isNps: {
      type: Boolean,
      default: false
    },
    topicSetting: {
      type: Object
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      hoverValue: props.value,
      hadClick: false,
      time: new Date().getTime()
    })
    const itemMouseover = (index) => {
      if (new Date().getTime() - state.time <= 300) {
        return
      }
      if (index + 1 > props.value) {
        if (props.isNps) {
          state.hoverValue = index
        } else {
          state.hoverValue = index + 1
        }
      }
    }
    const itemMouseout = () => {
      state.hoverValue = props.value
    }
    const itemClick = (index) => {
      //将答案值上传
      if (props.isNps) {
        emit('updateValue', index)
        state.hoverValue = index
      } else {
        emit('updateValue', index + 1)
        state.hoverValue = index + 1
      }
    }
    return () => {
      return (
        <div class="bar-score">
          {props.showTitle && (
            <div class="bar-score-top">
              <span
                class={{
                  'bar-score-top-bad': props.value === (props.isNps ? 0 : 1)
                }}>
                {props.minScoreDesc}
              </span>
              <span style={{ flex: 1 }}></span>
              <span
                class={{
                  'bar-score-top-good': props.value === props.maxScore
                }}>
                {props.maxScoreDesc}
              </span>
              {
                /* 根据后端条件判断要不要渲染 */
                !!props?.topicSetting?.customizeOption && (
                  <div class="cust-title">
                    {props?.topicSetting?.customizeOptionValue}
                  </div>
                )
              }
            </div>
          )}
          <div class="bar-score-middle">
            {new Array(props.isNps ? 11 : props.maxScore || 10)
              .fill(1)
              .map((sitem, index) => {
                return (
                  <div
                    onClick={() => itemClick(index)}
                    onmouseout={() => itemMouseout()}
                    onmouseover={() => itemMouseover(index)}
                    class={{
                      'bar-score-middle-item': true,
                      'bar-score-middle-item-active': ['', null].includes(
                        state.hoverValue
                      )
                        ? false
                        : (props.isNps ? index : index + 1) <= state.hoverValue
                    }}
                    key={index}>
                    {props.isNps ? index : index + 1}
                  </div>
                )
              })}
            {
              /* 根据后端条件判断要不要渲染 */
              !!props?.topicSetting?.customizeOption && (
                <Radio
                  key="npsRadio"
                  label={`-1:${props?.topicSetting?.customizeOptionValue}`}
                  value={props.value}
                  onInput={(value) => {
                    emit('updateValue', value)
                    state.hoverValue = ''
                  }}
                />
              )
            }
          </div>
        </div>
      )
    }
  }
})
export default BarScore
